import agent from "./agent";
import { ApiFactory } from "./ApiFactory";
import { ITableResult } from "../models/TableModel";

export default class TableApi {

    private apiFactory: ApiFactory;
    constructor(apiFactory: ApiFactory) {
        this.apiFactory = apiFactory;
    }

    /*
    Required Values to pass in:
    api as string

    Possible Values Passed In:
    -PageSize
    -Page
    -Filters
    -SortColumn
    -SortDirection

    Response Criteria:
    -data as an Array
    -rowCount as a number
    */
    async getResults<T = any> (api: string, values: any) {
            
        try {
            return await agent.api.getgeneric<ITableResult<T>>(api, values);
        }
        catch (error) {
            throw error;
        }

    }

}
